function handleDiagnosis(response, setStatus, handlerLoading) {
    if (response && response.diagnosis && response.diagnosis.length > 0) {
        setStatus('error', response.diagnosis[0].message);
    }

    handlerLoading(false);
}
export default handleDiagnosis;